(() => {
  const root = document.querySelector('[data-offer-two]');
  if (!root) return;
  const duration = 9 * 60 * 1000;
  const key = 'sr-offer-two-nine-minute-start';
  let start;
  try {
    start = Number(sessionStorage.getItem(key)) || Date.now();
    sessionStorage.setItem(key, start);
  } catch (_error) {
    start = Date.now();
  }
  const updateTimer = () => {
    const remaining = Math.max(0, Math.ceil((duration - (Date.now() - start)) / 1000));
    const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
    const seconds = String(remaining % 60).padStart(2, '0');
    root.querySelectorAll('[data-demo-timer]').forEach((element) => {
      element.textContent = `${minutes} : ${seconds}`;
    });
    const percent = (remaining / 540) * 100;
    root.querySelectorAll('[data-demo-progress]').forEach((element) => {
      element.style.width = `${percent}%`;
      element.parentElement.setAttribute('aria-valuenow', Math.round(percent));
    });
  };
  updateTimer();
  window.setInterval(updateTimer, 1000);

  const reviewRoot = root.querySelector('.mini-reviews');
  if (!reviewRoot) return;
  const track = reviewRoot.querySelector('.mini-review-track');
  const cards = [...reviewRoot.querySelectorAll('.mini-review')];
  const dots = [...reviewRoot.querySelectorAll('[data-review-dot]')];
  let index = 0;
  const showReview = (nextIndex) => {
    index = (nextIndex + cards.length) % cards.length;
    track.scrollTo({ left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  };
  new ResizeObserver(() => showReview(index)).observe(track);
  track.addEventListener('scroll', () => {
    index = Math.round(track.scrollLeft / track.clientWidth);
    dots.forEach((dot, dotIndex) => dot.toggleAttribute('aria-current', dotIndex === index));
  }, { passive: true });
  dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => showReview(dotIndex)));
  reviewRoot.querySelector('[data-review-prev]')?.addEventListener('click', () => showReview(index - 1));
  reviewRoot.querySelector('[data-review-next]')?.addEventListener('click', () => showReview(index + 1));
  track.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault();
    showReview(index + (event.key === 'ArrowRight' ? 1 : -1));
  });
})();
